/**
 * Kebab slug for a new dimension or family (WSRADM-0026).
 *
 * Moved from the deleted product-family board. Empty → `fallback` (default `family`).
 * Collision suffix `-{n}`. Result always matches `[a-z0-9-]{1,40}`.
 */

const SLUG_MAX = 40;

/**
 * Kebab slug from a display name. Empty → `fallback` (default `family`). Collision suffix `-{n}`.
 * Result always matches `[a-z0-9-]{1,40}`.
 */
export function slugFromDisplayName(
  displayName: string,
  existing: Iterable<string>,
  fallback = 'family',
): string {
  const taken = new Set(existing);
  let base = displayName
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  if (base.length === 0) base = fallback;
  if (base.length > SLUG_MAX) {
    base = base.slice(0, SLUG_MAX).replace(/-+$/, '');
    if (base.length === 0) base = fallback;
  }
  if (!taken.has(base)) return base;
  let n = 2;
  for (;;) {
    const suffix = `-${n}`;
    const room = SLUG_MAX - suffix.length;
    const candidate = `${base.slice(0, room)}${suffix}`;
    if (!taken.has(candidate)) return candidate;
    n += 1;
  }
}
